import React from "react";

const Calendar = () => {
  return (
    <svg
      className="calendar"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 73.8 74.4"
    >
      <title>Calendar</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            d="M73.8,9.2H57.6v5.2h11V27.6H5.2V14.4h11V9.2H0V74.4H73.8V36.1h0Zm-5.2,60H5.2V32.8H68.6V69.2Z"
          />
          <rect className="cls-1" x="48.9" width="5.2" height="20.6" />
          <rect className="cls-1" x="19.7" width="5.2" height="20.6" />
          <polygon
            className="cls-1"
            points="45.2 14.4 45.4 14.4 45.4 9.2 45.2 9.2 28.6 9.2 28.4 9.2 28.4 14.4 28.6 14.4 45.2 14.4"
          />
        </g>
      </g>
    </svg>
  );
};

export default Calendar;
